import * as React from 'react';
import { CircularProgress, TextField, Button, InputAdornment, TablePagination } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search'
import { SearchFilter } from '../../models/SearchFilter';
import { withRouter } from 'react-router';
import { roundedCorners } from '../../QmoTheme';
import { SupplierProductsSearchBoxProps } from '../connected/SupplierProductsSearchBoxCnn';
import SupplierProductList from './ProductList/SupplierProductList';
import { TaxonomyElement } from '../../api/models/TaxonomyElement';


const pageSizes = [10, 25, 50]

type State = {
    value: string,
    anhorElement?: HTMLElement,
    index?: any,
    quantities: { [prodId: string]: number },
    rowsPerPage: number,
    currentPage: number,
    highlights: { [id: string]: string[]},
}

class SupplierSearchBox extends React.Component<SupplierProductsSearchBoxProps, State> {
    constructor(props: SupplierProductsSearchBoxProps) {
        super(props);

        this.state = {
            value: '',
            quantities: {},
            rowsPerPage: pageSizes[0],
            currentPage: 0,
            highlights: {}
        }

        this.typingTimer = null
        this.executeSearch = this.executeSearch.bind(this)
        this.triggerSearch = this.triggerSearch.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.getCurrentProductsPage = this.getCurrentProductsPage.bind(this)
        this.loadMore = this.loadMore.bind(this)
    }

    typingTimer: NodeJS.Timeout | null

    componentDidUpdate(prevProps: SupplierProductsSearchBoxProps) {
        if (JSON.stringify(prevProps.appliedCategoryFilters) !== JSON.stringify(this.props.appliedCategoryFilters) ||
            JSON.stringify(prevProps.appliedPropertyFilters) !== JSON.stringify(this.props.appliedPropertyFilters)) {
            this.setState({ currentPage: 0 }, this.executeSearch)
        }

        if(prevProps.searchBusy && this.props.searchBusy === false){
            this.updateHighlights()
        }
    }

    componentWillMount() {
        if (this.props.taxonomy === null)
            this.props.loadTaxonomy()
    }

    componentDidMount() {
        if (this.props.predefinedSearchString) {
            this.executeSearch(this.props.predefinedSearchString)
            if (this.props.predefinedSearchString !== "*")
                this.setState({ value: this.props.predefinedSearchString! })
        }
    }

    executeSearch(searchPhrase: string | null = null) {
        console.log('Triggering search')

        function aggregateFilters(filters: SearchFilter[]): { [name: string]: string[] } {
            if (filters.length > 0)
                return filters.map((af) => af.toSolrFilter()).reduce((af1, af2) => {
                    if (af1[Object.keys(af2)[0]] !== undefined) {
                        af1[Object.keys(af2)[0]].push(Array.from(af2[Object.keys(af2)[0]])[0])
                        return af1
                    }
                    else
                        return Object.assign(af1, af2)
                })
            else
                return {}
        }

        let categoryFilters = aggregateFilters(this.props.appliedCategoryFilters)
        let propertyFilters = aggregateFilters(this.props.appliedPropertyFilters)
        let filter: { [name: string]: string[] } = Object.assign(categoryFilters, propertyFilters)
        this.props.searchTaxonomy(searchPhrase || this.state.value, this.state.currentPage * this.state.rowsPerPage, this.state.rowsPerPage, filter)
    }

    loadMore() {
        if (this.props.currentProducts.length < this.state.rowsPerPage * (this.state.currentPage + 1))
            this.executeSearch()
    }

    handleChangePage(event: any, page: number) {
        this.setState({ currentPage: page }, this.loadMore)
    }

    handleChangeRowsPerPage(event: any) {
        let visibleProducts = Math.min((this.state.currentPage) * this.state.rowsPerPage, this.props.currentProducts.length)
        this.setState({ rowsPerPage: event.target.value, currentPage: Math.floor((visibleProducts > 0 ? visibleProducts - 1 : 0) / Number(event.target.value)) }, this.loadMore)
    }

    getCurrentProductsPage(currentProducts: TaxonomyElement[]) {
        return this.props.currentProducts.slice(this.state.currentPage * this.state.rowsPerPage, this.state.currentPage * this.state.rowsPerPage + this.state.rowsPerPage)
    }

    triggerSearch() {
        if (this.typingTimer !== null) {
            clearTimeout(this.typingTimer)
        }
        let doneTypingInterval = 350
        this.typingTimer = setTimeout(() => { this.setState({ currentPage: 0 }, this.executeSearch) }, doneTypingInterval)
    }

    updateHighlights = () => {
        let hl = Object.assign({}, this.state.highlights, this.props.highlights)
        this.setState({ highlights: hl})
    }

    render() {
        return (
            <div>
                {this.props.taxonomy ?
                    <div>
                        <TextField placeholder={"Search in " + (this.props.appliedCategoryFilters.length > 0 ? this.props.appliedCategoryFilters[this.props.appliedCategoryFilters.length - 1].taxonomyReference!.name : "products")}
                            variant="outlined"
                            style={Object.assign({ width: "100%", backgroundColor: 'white' }, roundedCorners, { borderRadius: '100px' })}
                            value={this.state.value || ""}
                            onChange={(e) => {
                                this.setState({ value: e.target.value, highlights: {}})
                                this.triggerSearch()
                            }}
                            inputRef={(node) => this.state.anhorElement || this.setState({ anhorElement: node })}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button variant="contained" color="primary"
                                            style={{
                                                width: '56px', height: '56px',
                                                minWidth: 0,
                                                borderRadius: '100px',
                                                boxShadow: 'none',
                                                marginRight: '-14px',
                                                color: 'white'
                                            }}
                                            onClick={this.triggerSearch}
                                        >
                                            <SearchIcon />
                                        </Button>
                                    </InputAdornment>
                                ),
                            }}

                        />

                        <span>
                            <div style={{ marginTop: '15px' }}></div>

                            {/* <SearchFilters
                                isBusy={this.props.searchBusy}
                                filtersToPick={this.props.currentCategoryFilters}
                                appliedFilters={this.props.appliedCategoryFilters}
                                applyFilter={this.props.applyFilter}
                                removeFilter={this.props.removeFilter}

                                replaceFilter={this.props.replaceFilter}
                                appliedPropertyFilters={this.props.appliedPropertyFilters}
                                currentProductProperties={this.props.currentProductProperties}>
                            </SearchFilters> */}


                            <SupplierProductList
                                taxonomyLeafs={this.props.taxonomyLeafs}
                                taxonomy={this.props.taxonomy}
                                mappingObj={this.props.mappingObj}
                                pagination={
                                    <TablePagination
                                        style={{ float: 'left' }}
                                        rowsPerPageOptions={[]}
                                        component="div"
                                        count={this.props.totalResults}
                                        rowsPerPage={this.state.rowsPerPage}
                                        page={this.state.currentPage}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        labelRowsPerPage={""}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />}
                                searchValue={this.state.value}
                                highlights={this.state.highlights}
                                isBusy={this.props.searchBusy}
                                products={this.getCurrentProductsPage(this.props.currentProducts)}
                                onSaveChange={this.props.onSaveChange}
                                isUpdateMappingBusy={this.props.isUpdateMappingBusy}
                                onMappingFinish={this.props.onMappingFinish}
                                isUpdateMappingSuccess={this.props.isUpdateMappingSuccess}
                                showPriceControls={this.props.showPriceControls}
                                sendCatUpdateProposition={this.props.sendCatUpdateProposition}
                            />
                        </span>
                    </div>
                    :
                    <div style={{ minHeight: '100px', textAlign: "center" }}>
                        <CircularProgress size={60} />
                    </div>
                }
            </div>
        );
    }
}

export default withRouter(SupplierSearchBox);